import { Button } from '@mantine/core';
import { MyIcon } from '@web/common-ui';

export const BaseExportButton = ({
  label,
  onClick,
  disabled,
}: {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <Button
    w="300px"
    variant="outline"
    onClick={onClick}
    disabled={disabled}
    rightSection={<MyIcon name="export" style={{ fill: '#3D7F53' }} />}
  >
    {label}
  </Button>
);
